import e, { useContext as t } from "react";
//#region src/components/Map/Root/context.tsx
var n = e.createContext({}), r = () => t(n);
//#endregion
export { r as n, n as t };
